module.exports = __webpack_public_path__ + "static/media/react-logo-scaled.9c860644.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-logo-scaled.png
// module id = 59
// module chunks = 0